import { useState, useEffect, useRef, createRef } from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import { useSearchParams } from 'react-router-dom';
import { formatISO, isValid } from 'date-fns';
import {
  Grid,
  Switch,
  styled,
  Button,
  TextField,
  InputLabel,
  FormControlLabel,
} from '@mui/material';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import {
  TextWithCount,
  ThumbUploadField,
  AsyncSelectField,
} from 'components/Fields';
import { adminAPI } from 'services/admin';
import { TargetAudiencesField } from 'components/Fields/TargetAudiencesField';
import { AgeRatingField } from './AgeRatingField';
import { Keysfield } from './KeysField';
import { AllowedDeniedCountriesField } from './AllowedDeniedCountriesField';
import _ from 'lodash';
import { useNotification } from 'hooks/useNotification';
import { getAuthData } from 'utils/authentication';

function StepThree({
  watch,
  errors,
  register,
  control,
  setValue,
  getValues,
  viewFields,
  wordsList,
  keyWordsList,
  setWordsList,
  selectedOption,
  setKeyWordsList,
  setSelectedOption,
  canShowPublishIn = false
}) {
  const { openNotification } = useNotification();
  const [searchParams] = useSearchParams();
  const [countriesList, setCountriesList] = useState([]);
  const keyWordsRef = useRef(null);

  const launchingCountryRef = createRef();
  const [personalitiesCredits] = useState([]);

  const getCountries = async () => {
    try {
      const { session } = await getAuthData();
      const path = `/admin/countries`;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return await adminAPI.get(path, data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectedKeyWords = values => {
    setValue('wordsSelectedFromKey', values);
  };

  const IOSSwitch = styled(props => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 40,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor:
            theme.palette.mode === 'dark' ? '#2ECA45' : 'rgba(0, 62, 108, 1)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 20,
      height: 20,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  //Set defaultvalue for react-selects
  const handleSelectedOptionChange = (selectId, selected) => {
    setSelectedOption(prevSelectedOptions => ({
      ...prevSelectedOptions,
      [selectId]: selected,
    }));
    setValue('selected_key', selected);
  };

  useEffect(() => {
    if (searchParams) {
      // let queryPath = "";
      if (searchParams.get('keyword')) {
        let keyword = JSON.parse(searchParams.get('keyword'));
        handleSelectedOptionChange('keyword', keyword);
        // queryPath += `&keywordId=${keyword.value}`;
      }
      if (searchParams.get('channel')) {
        let channel = JSON.parse(searchParams.get('channel'));
        handleSelectedOptionChange('channel', channel);
        // queryPath += `&channelId=${channel.value}`;
      }
      if (searchParams.get('personalities')) {
        let personalities = JSON.parse(searchParams.get('personalities'));
        handleSelectedOptionChange('personalities', personalities);
        // queryPath += `&personalitiesId=${personalities.value}`;
      }
      if (searchParams.get('personalitiesCredits')) {
        let personalitiesCredits = JSON.parse(
          searchParams.get('personalitiesCredits')
        );
        handleSelectedOptionChange(
          'personalitiesCredits',
          personalitiesCredits
        );
        // queryPath += `&personalitiesCreditsId=${personalitiesCredits.value}`;
      }
      // setFilterPath(queryPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalitiesCredits]);

  useEffect(() => {
    if (countriesList.length === 0) getAllCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllCountries = async () => {
    let response = await getCountries();
    let paisTemp = [];
    if (response?.countryList?.length) {
      for (let c of response.countryList) {
        paisTemp.push({
          acronym: c.acronym,
          id: c.id,
          label: c.name,
          value: c.id,
          countryId: c.id,
        });
      }
    }
    setCountriesList(paisTemp);
  };

  const addKeyWords = () => {
    let keywordsTemp = getValues('wordsSelectedFromKey');
    let selected_key = getValues('selected_key');

    if (!selected_key) {
      openNotification({
        message: 'Selecione uma chave para adiciona-la.',
        type: 'info',
        title: "Campo 'Chave' não pode ser vazio.",
      });
      return;
    }
    if (keywordsTemp.length === 0) {
      openNotification({
        message: 'Selecione um valor para a chave.',
        type: 'info',
        title: "Campo 'Palavra' não pode ser vazio.",
      });
      return;
    }

    const selectedKeys = keywordsTemp?.map(item => ({
      key: selected_key.label,
      value: item.value,
    }));

    const keyWords = getValues('keywords');

    const mergedKeys = _.uniqWith(
      [...keyWords, ...selectedKeys],
      (obj1, obj2) => {
        return obj1.value === obj2.value && obj1.key === obj2.key;
      }
    );

    setValue('keywords', mergedKeys);

    keyWordsRef?.current?.clearValue();
  };

  return (
    <div id="step-three">
      <div className="step-container">
        <Grid container spacing={2}>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <div className="video_label-title">Dados Obrigatórios</div>
              <TextWithCount
                name="title"
                label="Título"
                placeholder="Digite o título"
                maxLength={72}
                control={control}
                disabled={viewFields}
              />
            </Grid>
            <Grid item xs={6}>
              <TargetAudiencesField
                name="targetAudiences"
                control={control}
                disabled={viewFields}
              />
            </Grid>
            <Grid item xs={6}>
              <AgeRatingField
                control={control}
                watch={watch}
                viewFields={viewFields}
                setValue={setValue}
              />
            </Grid>
          </Grid>

          <Grid item xs={8}>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label mb-3" htmlFor="name">
                País(es) de origem -{' '}
                <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 5)</span>
              </InputLabel>

              <Controller
                name={'launchingCountry'}
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value, onBlur } }) => {
                  return (
                    <Select
                      id="video-lauching-country"
                      isMulti
                      placeholder="Selecione o(s) país(es)"
                      options={countriesList}
                      onChange={values => {
                        onChange(
                          values?.map(country => ({
                            countryId: country.value,
                            name: country.label,
                          }))
                        );
                      }}
                      onBlur={onBlur}
                      value={value?.map(({ countryId, name }) => ({
                        value: countryId,
                        label: name,
                      }))}
                      isOptionDisabled={() => value?.length >= 5}
                      selectRef={launchingCountryRef}
                      isDisabled={viewFields}
                    />
                  );
                }}
              />
              {errors.launchingCountry &&
              errors.launchingCountry.type === 'required' ? (
                <div className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null}
            </Form.Group>
          </Grid>

          <Grid item xs={4}>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel
                className="form-label"
                htmlFor="name"
                style={{ marginBottom: 0 }}>
                Ano
              </InputLabel>

              <Controller
                name="launchYear"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value, onBlur } }) => (
                  <DatePicker
                    format="yyyy"
                    value={value ? new Date('01/01/' + value) : null}
                    onBlur={onBlur}
                    maxDetail="decade"
                    showYearPicker
                    onChange={newValue => {
                      if (
                        new Date(newValue).getFullYear() >
                        new Date().getFullYear()
                      ) {
                        openNotification({
                          message:
                            'Ano de lançamento não pode ser posterior ao ano atual!',
                          type: 'info',
                          title: 'Atenção!',
                        });
                        return;
                      }
                      onChange(
                        newValue ? dayjs(new Date(newValue)).year() : null
                      );
                    }}
                    disabled={viewFields}
                    className="custom-datepicker-year"
                    id="video-launch-year"
                  />
                )}
              />
              {errors.launchYear && errors.launchYear.type === 'required' ? (
                <div className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null}
            </Form.Group>
          </Grid>
          <Grid item xs={12}>
            <TextWithCount
              name="shortDescription"
              label="Descrição curta"
              placeholder="Descrição curta"
              maxLength={140}
              control={control}
              disabled={viewFields}
              multiline
            />
            <TextWithCount
              name="fullDescription"
              label="Descrição longa"
              placeholder="Descrição longa"
              maxLength={5000}
              control={control}
              disabled={viewFields}
              multiline
            />
            <TextWithCount
              name="technicalSheet"
              label="Ficha técnica"
              placeholder="Ficha técnica"
              maxLength={3000}
              control={control}
              disabled={viewFields}
              multiline
            />
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label" htmlFor="name">
                Crédito -{' '}
                <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 5)</span>
              </InputLabel>
              <AsyncSelectField
                id="video-credits"
                name="personalitiesCredits"
                isMulti
                placeholder="Buscar..."
                control={control}
                url="/admin/personalities?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="personalityList"
                isDisabled={viewFields}
                isOptionDisabled={personalitiesCredits =>
                  personalitiesCredits.length >= 5
                }
                controllerProps={{
                  rules: {
                    required: 'Campo é obrigatório',
                    validate: value => {
                      if (
                        typeof value === 'object' &&
                        Object.keys(value).length === 0
                      ) {
                        return 'This field is required.';
                      }
                      return true;
                    },
                  },
                }}
              />
              {errors.personalitiesCredits &&
              errors.personalitiesCredits.type === 'required' ? (
                <div className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null}
            </Form.Group>

            <Form.Group
              className="mb-3"
              style={{ height: 'auto' }}
              controlId="formUnit">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="units">
                Unidades
              </InputLabel>
              <AsyncSelectField
                id="video-units"
                name="units"
                isMulti
                placeholder="Buscar..."
                isDisabled={viewFields}
                control={control}
                url="/admin/units?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="unitList"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">Opcional</label>
                <InputLabel className="form-label" htmlFor="name">
                  Canal
                </InputLabel>
              </div>

              <AsyncSelectField
                id="video-channels"
                name="channels"
                isMulti
                placeholder="Buscar..."
                isDisabled={viewFields}
                control={control}
                url="/admin/channels?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="channelList"
              />
            </Form.Group>
            {canShowPublishIn && (
              <Form.Group className="mb-3" controlId="formName">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <span
                      style={{
                        marginRight: 16,
                        fontWeight: '500',
                        fontSize: 14,
                        color: 'rgba(93, 88, 108, 1)',
                      }}>
                      Data início de veiculação
                    </span>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          disabled={viewFields}
                          sx={{ m: 1 }}
                          name="hasPublishIn"
                          checked={watch('hasPublishIn')}
                          onChange={e => {
                            setValue('hasPublishIn', e.target.checked);

                            if (!e.target.checked) setValue('publishIn', null);
                          }}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                    />
                  </div>

                  <Controller
                    name="publishIn"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const isFieldDisabled = watch('hasPublishIn');

                      return (
                        <DatePicker
                          disabled={viewFields}
                          locale="pt-BR"
                          id="video-publish-in"
                          className={`${
                            isFieldDisabled
                              ? 'custom-datepicker-year '
                              : 'custom-datepicker-year disabled-menu'
                          }`}
                          enabled={isFieldDisabled}
                          value={value ? new Date(value) : null}
                          onChange={newValue => {
                            if (!isValid(newValue)) return;

                            if (new Date(newValue) < new Date()) {
                              openNotification({
                                message:
                                  'A data início de veiculação não pode ser anterior ou igual a data atual!',
                                type: 'info',
                                title: 'Atenção.',
                              });
                              return;
                            }

                            const changedValue = formatISO(new Date(newValue));
                            isValid(new Date(changedValue)) &&
                              onChange(changedValue);
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </Form.Group>
            )}
            <Form.Group className="mb-3" controlId="formName">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <span
                    style={{
                      marginRight: 16,
                      fontWeight: '500',
                      fontSize: 14,
                      color: 'rgba(93, 88, 108, 1)',
                    }}>
                    Data limite de veiculação
                  </span>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        disabled={viewFields}
                        sx={{ m: 1 }}
                        name="hasExpiresIn"
                        checked={watch('hasExpiresIn')}
                        onChange={e => {
                          setValue('hasExpiresIn', e.target.checked);

                          if (!e.target.checked) setValue('expiresIn', null);
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                  />
                </div>

                <Controller
                  name="expiresIn"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    const isFieldDisabled = watch('hasExpiresIn');

                    return (
                      <DatePicker
                        disabled={viewFields}
                        locale="pt-BR"
                        id="video-expires-in"
                        className={`${
                          isFieldDisabled
                            ? 'custom-datepicker-year '
                            : 'custom-datepicker-year disabled-menu'
                        }`}
                        enabled={isFieldDisabled}
                        value={value ? new Date(value) : null}
                        onChange={newValue => {
                          if (!isValid(newValue)) return;

                          if (new Date(newValue) < new Date()) {
                            openNotification({
                              message:
                                'A data limite de veiculação não pode ser anterior ou igual a data atual!',
                              type: 'info',
                              title: 'Atenção.',
                            });
                            return;
                          }

                          const changedValue = formatISO(new Date(newValue));
                          isValid(new Date(changedValue)) &&
                            onChange(changedValue);
                        }}
                      />
                    );
                  }}
                />
              </div>
            </Form.Group>




            <Form.Group className="mb-3" controlId="formName">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <span
                    style={{
                      marginRight: 16,
                      fontWeight: '500',
                      fontSize: 14,
                      color: 'rgba(93, 88, 108, 1)',
                    }}>
                    Visível somente nas Coleções e Séries
                  </span>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        disabled={viewFields}
                        sx={{ m: 1 }}
                        name="searchable"
                        checked={watch('searchable') === false}
                        onChange={e => {
                          const newValue = !e.target.checked;
                          console.log('Switch mudou:', {
                            switchChecked: e.target.checked,
                            searchableValue: newValue,
                          });
                          setValue('searchable', newValue);
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                  />
                </div>
              </div>
            </Form.Group>
            <AllowedDeniedCountriesField
              watch={watch}
              control={control}
              setValue={setValue}
              getValues={getValues}
              viewFields={viewFields}
              countriesList={countriesList}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Form.Group
                style={{ width: '48%' }}
                className="mb-3"
                controlId="formName">
                <InputLabel className="form-label" htmlFor="name">
                  Limite de Players para o vídeo
                </InputLabel>

                <Controller
                  name="viewsLimit"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      className="mt-2"
                      fullWidth
                      placeholder=""
                      variant="standard"
                      type="number"
                      id="video-view-limit"
                      onChange={e => {
                        const newValue = e.target.value;
                        newValue >= 0 && onChange(+newValue);
                      }}
                      value={value}
                      aria-invalid={errors.limit_views ? 'true' : 'false'}
                      onBlur={e => {
                        // trigger(e.target.limit_views);
                      }}
                      disabled={viewFields}
                    />
                  )}
                />
              </Form.Group>

              <Form.Group
                style={{ width: '48%' }}
                className="mb-3"
                controlId="filled-views">
                <InputLabel className="form-label" htmlFor="name">
                  Visualizações atuais
                </InputLabel>
                <Controller
                  name="totalViews"
                  control={control}
                  render={({ field: { value } }) => (
                    <TextField
                      className="mt-2"
                      fullWidth
                      inputProps={{
                        readOnly: true,
                      }}
                      placeholder=""
                      variant="standard"
                      id="video-views-now"
                      value={value}
                      defaultValue={0}
                    />
                  )}
                />
              </Form.Group>
            </div>
          </Grid>

          <Grid item xs={12}>
            <ThumbUploadField
              watch={watch}
              control={control}
              register={register}
              getValues={getValues}
              viewFields={viewFields}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="video_label-title">Dados Opcionais</div>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label" htmlFor="name">
                Com quem -{' '}
                <span style={{ fontSize: 12, color: '#6082B6' }}>
                  (Máx. 20)
                </span>
              </InputLabel>
              <AsyncSelectField
                id="video-personalities"
                name="personalities"
                isMulti
                placeholder="Buscar..."
                control={control}
                isDisabled={viewFields}
                url="/admin/personalities?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="personalityList"
              />
            </Form.Group>
          </Grid>

          <Grid item xs={4}>
            <Form.Group className="mb-3" controlId="formChave">
              <InputLabel className="form-label" htmlFor="chave">
                Chave
              </InputLabel>
              <AsyncSelectField
                id="video-selected-key"
                name="selected_key"
                placeholder="Buscar..."
                control={control}
                loadOptions={async (search, prevOptions) => {
                  if (search.length < 3)
                    return {
                      options: [],
                      hasMore: false,
                    };

                  const newOffset = prevOptions.length;
                  const requestUrl =
                    '/admin/keywords?performance=true&limit=10&key=#key&sortBy=name&offset=#offset'
                      .replace('#key', search)
                      .replace('#offset', newOffset);

                  try {
                    const response = await adminAPI.get(requestUrl);

                    const data = response.keywordList;
                    const total = response.totalItemsCountFiltered;
                    setKeyWordsList(data);
                    const optionsResult = data.map(data => ({
                      label: data.key,
                      value: data.id,
                    }));

                    const hasMore = newOffset + optionsResult.length < total;

                    return {
                      options: optionsResult,
                      hasMore: hasMore,
                    };
                  } catch (error) {
                    return { options: [], hasMore: false };
                  }
                }}
                isDisabled={viewFields}
                value={
                  selectedOption.keyword
                    ? selectedOption.keyword
                    : { value: 'all', label: 'Selecionar a chave' }
                }
                onChange={selected => {
                  if (keyWordsList?.length) {
                    keyWordsRef?.current?.clearValue();
                    setValue('wordsSelectedFromKey', []);

                    const selectedKeyItem = keyWordsList.find(
                      item => selected?.label === item.key
                    );

                    if (selectedKeyItem) {
                      const valArray = [
                        ...(selectedKeyItem.values || []),
                        ...(selectedKeyItem.value || []),
                      ].map(val => ({ label: val, value: val }));
                      setWordsList(valArray);
                    }
                  }
                  handleSelectedOptionChange('keyword', selected);
                }}
              />
            </Form.Group>
          </Grid>

          <Grid item xs={8}>
            <Form.Group className="mb-3" controlId="formKeywords">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="values">
                Palavra
              </InputLabel>
              <Controller
                name="wordsSelectedFromKey"
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <Select
                    isMulti
                    name="wordsSelectedFromKey"
                    isSearchable={true}
                    ref={keyWordsRef}
                    isClearable={true}
                    placeholder={'Selecione a(s) palavra(s)'}
                    options={wordsList}
                    onChange={handleSelectedKeyWords}
                    onBlur={onBlur}
                    isDisabled={viewFields}
                    id="video-words-selected-from-key"
                  />
                )}
              />
            </Form.Group>
          </Grid>

          <Grid item xs={12}>
            <Button
              disabled={viewFields}
              style={{
                textTransform: 'initial',
              }}
              component="label"
              onClick={addKeyWords}
              id="video-add-keyword-button">
              + Adicionar palavra(s) chave(s)
            </Button>
          </Grid>
          <Keysfield control={control} viewFields={viewFields} />
        </Grid>
      </div>
    </div>
  );
}

export default StepThree;
